import React from 'react';
import styles from './RestrictedAccess.module.css';

const RestrictedAccess = () => {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.icon}>🔒</div>
        <h1 className={styles.title}>Restricted Access</h1>
        <p className={styles.message}>
          This path is restricted to administrators and authors only. 
          Please log in with appropriate credentials to access this area.
        </p>
        <a href="/signin" className={styles.button}>
          Login
        </a>
      </div>
    </div>
  );
};

export default RestrictedAccess;